(() => {
  // --- small utility: wait for an element ---
  const waitFor = (selector, {root = document, tries = 60, delay = 250} = {}) =>
    new Promise(resolve => {
      const t = setInterval(() => {
        const el = root.querySelector(selector);
        if (el || --tries <= 0) { clearInterval(t); resolve(el || null); }
      }, delay);
    });

  // Bind once helper
  const bindOnce = (el, type, handler, key) => {
    if (!el) return;
    const k = `__bound_${key || type}`;
    if (el[k]) return;
    el.addEventListener(type, handler);
    el[k] = true;
  };

  const applyFix = async () => {
    // Drawer + parts (support both id and class variations)
    const drawer =
      document.querySelector('details#Details-menu-drawer-container') ||
      document.querySelector('details.menu-drawer-container') ||
      await waitFor('details#Details-menu-drawer-container');

    if (!drawer) return;

    const summary =
      drawer.querySelector('summary.header__icon--menu, summary.header__icon') ||
      drawer.querySelector('summary');

    const menu = drawer.querySelector('.menu-drawer');
    const closeBtn =
      drawer.querySelector('button[aria-label="Cerrar"], .menu-drawer__close-button, [on\\:click="header-drawer/close"]');

    const backdrop = drawer.querySelector('.menu-drawer__backdrop');

    // If theme/section rebuilt without menu content yet, bail (will retry on next event).
    if (!summary || !menu) return;

    // Ensure backdrop is clickable
    if (backdrop) {
      backdrop.style.pointerEvents = 'auto';
      backdrop.style.zIndex = '99998';
    }

    // Open / close
    const openDrawer = () => {
      drawer.setAttribute('open', 'true');
      drawer.style.opacity = '1';
      drawer.style.visibility = 'visible';
      drawer.style.pointerEvents = 'auto';
      if (menu) {
        menu.style.opacity = '1';
        menu.style.visibility = 'visible';
        menu.style.pointerEvents = 'auto';
        menu.style.display = 'block';
        menu.style.transform = 'translateX(0)';
        menu.style.zIndex = '99999';
      }
    };

    const closeDrawer = () => {
      drawer.removeAttribute('open');
      if (menu) {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
        menu.style.pointerEvents = 'none';
        menu.style.display = 'none';
      }
    };

    // Prevent double-binding across section reloads
    bindOnce(summary, 'click', (e) => {
      e.preventDefault();
      drawer.hasAttribute('open') ? closeDrawer() : openDrawer();
    }, 'menu_toggle');

    if (closeBtn) bindOnce(closeBtn, 'click', (e) => { e.preventDefault(); closeDrawer(); }, 'menu_close_btn');
    if (backdrop) bindOnce(backdrop, 'click', (e) => { e.preventDefault(); closeDrawer(); }, 'menu_backdrop');

    // Also close on ESC
    bindOnce(document, 'keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) closeDrawer();
    }, 'menu_esc');
  };

  // Initial run (after DOM is ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix, {once: true});
  } else {
    applyFix();
  }

  // Re-run when Shopify dynamically reloads sections or route changes
  document.addEventListener('shopify:section:load', applyFix);
  document.addEventListener('shopify:section:unload', applyFix);
  document.addEventListener('page:load', applyFix);        // some themes use Turbo/instant transitions
  document.addEventListener('ajaxComplete', applyFix);     // safety net for apps/builders

  // MutationObserver as last resort (handles Beae/Builder DOM swaps)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) { applyFix(); break; }
    }
  });
  mo.observe(document.documentElement, {childList: true, subtree: true});
})();
